import axios from "axios";
import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const uploadImage = async (category, image) => {
        try {
            const formData = new FormData();
            formData.append('file', image);
            
            const response = await axios.post(`/media/upload?category=${category}`, formData, {
                headers: {
                'Accept': '*/*',
                'Content-Type': 'multipart/form-data',
                },
            });

            return response;
            
        } catch (error) {
            console.error('Erreur lors de l\'upload de l\'image:', error);
            throw error;
        }
  };

  export const getAllMedia = async () => {
      try {
        const response = await api.get(`/media/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getMediaById = async (fileName) => {
      try {
        const response = await api.get(`/media/${fileName}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const downloadMedia = async ( fileName) => {
      try {
        const response = await api.get(`/media/download/${fileName}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteMedia = async (fileName) => {
    try {
        const response = await api.delete(`media/delete/${fileName}`);
        return response;
    } catch (error) {
        throw error;
    }
  };